module.exports = __webpack_public_path__ + "static/media/nuova-3-comp.f38c12d2.jpg";